import React from "react";
import Card from "@vapor/react-material/Card";
import CardContent from "@vapor/react-material/CardContent";
import CardActions from "@vapor/react-material/CardActions";
import Button from "@vapor/react-material/Button";
import LogoutIcon from "@mui/icons-material/Logout";
import User from "@vapor/react-icons/User";
import Avatar from "@vapor/react-extended/ExtendedAvatar";
import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";
import Box from "@vapor/react-material/Box";
import Divider from "@vapor/react-material/Divider";
import { UserAgent } from "../types.ts";

interface UserProps {
  user: UserAgent;

}


const UserCard: React.FC<UserProps> = ({ user }) => {
  const { username, firstname, lastname, email } = user;
  return (
    <>
      <Card
        sx={{
          width: 560,
          marginTop: 1
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <CardContent sx={{ display: "center", textAlign: "center" }}>
            <Avatar size="small" disabled>
              <User />
            </Avatar>
            <ExtendedTypography
              color="primary.interactiveDefault"
              variant="subtitle"
              sx={{ m: 2 }}
            >
              {firstname} {lastname}
            </ExtendedTypography>
          </CardContent>
          <CardActions>
            <Button size="medium">
              <LogoutIcon />
            </Button>
          </CardActions>
        </Box>
        <Box
          height={50}
          sx={{
            backgroundColor: "#e3f5ff",
            display: "flex",
            justifyContent: "space-between"
          }}
        >
          <ExtendedTypography
            variant="body"
            sx={{ marginLeft: 2, marginTop: 2 }}
          >
            Nome utente: <strong>{username}</strong>
          </ExtendedTypography>
          <ExtendedTypography
            variant="body"
            sx={{ marginRight: 8, marginTop: 2 }}
          >
            Email: <strong>{email}</strong>
          </ExtendedTypography>
        </Box>
      </Card>
      <Divider light sx={{ marginTop: 3, marginRight: 3 }} />
    </>
  );
};

export default UserCard;
